var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"pa-0 ma-0"},[(_vm.unreadReservationsCount === 0)?_c('guest-list-placeholder',{attrs:{"title":_vm.$t('placeholder.no_unread_reservation')}}):_c('guest-results-list',{attrs:{"show-unread":"","reservations":_vm.unreadReservations}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }